module.exports = __webpack_public_path__ + "img/img_ reportforms_retail@3x.1015b090.png";